import { useState, useEffect } from 'react';

const useScrollProgress = (className) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  const updateScrollProgress = () => {
    const contentElement = document.querySelector(className);
    if (contentElement) {
      const contentTop = contentElement.offsetTop;
      const contentHeight = contentElement.scrollHeight;
      const scrollPosition = window.pageYOffset;

      if (
        scrollPosition >= contentTop &&
        scrollPosition <= contentTop + contentHeight
      ) {
        const scrollPercent =
          ((scrollPosition - contentTop) /
            (contentHeight - window.innerHeight)) *
          100;
        setScrollProgress(scrollPercent);
      } else if (scrollPosition < contentTop) {
        setScrollProgress(0);
      } else {
        setScrollProgress(100);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScrollProgress);
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);

  return scrollProgress;
};

export default useScrollProgress;
